import { defineMessages } from 'react-intl'

export default defineMessages({
  htmlEmbedEmptyTitle: { defaultMessage: '(Fill in HTML embed code here)' },
})
